// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`CustomLink test Match con el snapshot 1`] = `
<div class="container">
    <p class="disable-selection"></p>
</div>
`;
